import styled from "styled-components";

export const StyledFooter = styled.footer`
  flex-direction: column;
  height: auto;
  min-height: 70px;
  padding: 15px;
  text-align: center;
  color: #4e878c;
`;

export const StyledSocialLinks = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
    width: 100%;
    max-width: 80px;
    margin: 0 auto 10px;
    color: #4e878c;
  }

  ul {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    justify-content: space-between;
    align-items: center;

    a {
      padding: 10px;
      display: inline-block;
      transition: transform 0.3s ease-out;

      &:hover,
      &:focus {
        transform: translateY(-5px);
        color: #4e878c;
      }

      svg {
        width: 20px;
        height: 20px;
        color: #4e878c;
        transition: transform 0.3s ease-out;
      }
    }
  }
`;

export const StyledCredit = styled.div`
  color: #4e878c;
  line-height: 1;

  a {
    padding: 10px;
  }

  .github-stats {
    margin-top: 10px;

    & > span {
      display: inline-flex;
      align-items: center;
      margin: 0 7px;
    }

    svg {
      display: inline-block;
      margin-right: 5px;
      width: 14px;
      height: 14px;
    }
  }
`;
